export default "__VITE_ASSET__CJs$nBzB__"